import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { Col, Row, Button, Spinner } from "reactstrap";
import DataTable from "../../shared/base-components/DataTable";
import { useStaffDeleteMutation, useStaffListMutation } from "./Staff.actions";
import { Personel } from "./Staff.constants";
import StaffModal from "./StaffModal";
import {
  MODAL_TYPES,
  Permissions,
  RESPONSE_CODE,
} from "../../shared/models/Types";
import StaffDeleteModal from "./StaffDeleteModal";
import { Email } from "../../shared/base-components/DataTable/DataTable.Col";
import { formatDateString, formatDecimal } from "../../shared/utils/formatText";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../shared/actions/Authentication.actions";
import StaffDetailModal from "./StaffDetailModal";
import { postMessagePersonelLocation } from "../../shared/internals/asd";
import { webViewSelector } from "../../shared/actions/LayoutMode.actions";

const StaffList = () => {
  document.title =
    "Personeller | Bu ekranda personel ekleme güncelleme yapabilirsiniz.";

  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const permissionList = useRecoilValue(permissionsSelector);
  const isWebView = useRecoilValue(webViewSelector);

  const { data, mutate, isLoading } = useStaffListMutation();

  const [isLocationSelect, setIsLocationSelect] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalOptions, setModalOptions] = useState<{
    data?: Personel;
    modalType?: string;
  }>({
    data: undefined,
    modalType: undefined,
  });

  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const modalOptionsHandler = (data?: Personel, modalType?: string) => {
    setModalOptions({ data: data, modalType: modalType });
  };

  const addPermission = permissionList[Permissions.AddUser];
  const updatePermission = permissionList[Permissions.ChangeUser];
  const viewPermission = permissionList[Permissions.ViewUser];
  const deletePermission = permissionList[Permissions.DeleteUser];

  const columns = useMemo(
    () => [
      {
        Header: "Tam Ad",
        filterable: false,
        disableFilters: true,
        accessor: "fullname",
        Cell: (user: any) => (
          <>
            <h5 className="font-size-14 mb-1">{user.row.original.fullname}</h5>
          </>
        ),
      },
      {
        Header: "Kullanıcı Adı",
        filterable: false,
        disableFilters: true,
        accessor: "username",
        Cell: (user: any) => (
          <>
            <p className="text mb-0">{user.row.original.username}</p>
          </>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: false,
        disableFilters: true,
        Cell: (cellProps: any) => {
          return <Email {...cellProps} />;
        },
      },
      {
        Header: "Telefon",
        accessor: "phone_number",
        filterable: false,
        disableFilters: true,
        Cell: (user: any) => (
          <>
            <p className="text mb-0">{user.row.original.phone_number}</p>
          </>
        ),
      },
      {
        Header: "Net Maaş",
        accessor: "salary_net",
        filterable: false,
        disableFilters: true,
        Cell: (user: any) => (
          <>
            <p className="text mb-0">
              {formatDecimal(user.row.original.salary_net)} ₺
            </p>
          </>
        ),
      },
      {
        Header: "Başlama Tarihi",
        accessor: "date_of_start",
        filterable: false,
        disableFilters: true,
        Cell: (user: any) => (
          <>
            <p className="text mb-0">
              {user.row.original.date_of_start.split("T")[0]}
            </p>
          </>
        ),
      },
      {
        Header: "Konum Takip",
        accessor: "is_visible",
        filterable: true,
        sortable: true,
        disableFilters: true,
        Cell: (response: any) => {
          const isActive = response.row.original.can_follow;
          const color = isActive ? "success" : "danger";
          return (
            <div
              className={
                "badge bg-" + color + "-subtle text-" + color + " font-size-12"
              }
            >
              {isActive ? "Var" : "Yok"}
            </div>
          );
        },
      },
      {
        Header: "İşlemler",
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              {updatePermission && (
                <Link className="text-warning" to="#">
                  <i
                    className="mdi mdi-pencil font-size-18"
                    id="edittooltip"
                    onClick={() => {
                      const userData = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(userData, MODAL_TYPES.UPDATE);
                    }}
                  ></i>
                </Link>
              )}

              {deletePermission && (
                <Link className="text-danger" to="#">
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                    onClick={() => {
                      const userData = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(userData, MODAL_TYPES.DELETE);
                    }}
                  ></i>
                </Link>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const mobileColumns = useMemo(
    () => [
      {
        Header: "Ad Soyad",
        filterable: false,
        disableFilters: true,
        accessor: "fullname",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {response.row.original.fullname}
            </h5>
          </>
        ),
      },
      {
        Header: "İşlemler",
        accessor: "phone_number",
        disableFilters: true,
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              {isWebView && (
                <div>
                  <Link
                    to={"#"}
                    onClick={() =>
                      setIsLocationSelect(cellProps.row.original.id)
                    }
                    type="button"
                    className="btn btn-soft-success"
                  >
                    <i className="bx bx-current-location"></i>
                  </Link>
                </div>
              )}

              {updatePermission && (
                <Link className="text-warning" to="#">
                  <i
                    className="mdi mdi-pencil font-size-18"
                    id="edittooltip"
                    onClick={() => {
                      const userData = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(userData, MODAL_TYPES.UPDATE);
                    }}
                  ></i>
                </Link>
              )}
              {deletePermission && (
                <Link className="text-danger" to="#">
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                    onClick={() => {
                      const userData = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(userData, MODAL_TYPES.DELETE);
                    }}
                  ></i>
                </Link>
              )}

              <Link className="text-success" to="#">
                <i
                  className="mdi mdi-eye font-size-18"
                  id="deletetooltip"
                  onClick={() => {
                    const userData = cellProps.row.original;

                    toggle();
                    modalOptionsHandler(userData, MODAL_TYPES.DETAIL);
                  }}
                ></i>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    mutate({});
  }, []);

  useEffect(() => {
    if (isLocationSelect > 0) {
      postMessagePersonelLocation(isLocationSelect);
      setIsLocationSelect(0);
    }
  }, [isLocationSelect]);

  return (
    <React.Fragment>
      <Row className="align-items-center">
        <Col md={6}>
          <div className="mb-3">
            <h5 className="card-title">
              Personel Listesi
              <span className="text-muted fw-normal ms-2">
                {isLoading ? (
                  <Spinner className="ms-1" color="primary" />
                ) : (
                  `(${data?.length})`
                )}
              </span>
            </h5>
          </div>
        </Col>

        <Col md={6}>
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
            <div>
              <ul className="nav nav-pills"></ul>
            </div>
            <div>
              {addPermission && (
                <Button
                  onClick={() => {
                    toggle();
                    modalOptionsHandler(undefined, MODAL_TYPES.CREATE);
                  }}
                  className="btn btn-light"
                >
                  <i className="bx bx-user-plus me-1"></i> Personel Ekle
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          {data?.length && viewPermission && (
            <DataTable
              columns={isMobile ? mobileColumns : columns}
              data={data}
              isGlobalFilter={true}
              isAddUserList={true}
              customPageSize={10}
              className="table align-middle datatable dt-responsive table-check nowrap"
            />
          )}
        </Col>
      </Row>

      {isModalOpen &&
        updatePermission &&
        (modalOptions.modalType === MODAL_TYPES.CREATE ||
          modalOptions.modalType === MODAL_TYPES.UPDATE) && (
          <StaffModal
            userData={modalOptions.data}
            modalType={modalOptions.modalType}
            isModalOpen={isModalOpen}
            toggle={toggle}
            mutate={mutate}
          />
        )}

      {isModalOpen &&
        deletePermission &&
        modalOptions.modalType === MODAL_TYPES.DELETE && (
          <StaffDeleteModal
            userData={modalOptions.data}
            modalType={modalOptions.modalType}
            isModalOpen={isModalOpen}
            toggle={toggle}
          />
        )}

      {isModalOpen &&
        viewPermission &&
        modalOptions.modalType === MODAL_TYPES.DETAIL && (
          <StaffDetailModal
            userData={modalOptions.data}
            modalType={modalOptions.modalType}
            isModalOpen={isModalOpen}
            toggle={toggle}
          />
        )}
    </React.Fragment>
  );
};

export default StaffList;
